import { AlertDialogProps, Button, Dialog, toast } from '@highmobility/console-ui-components';
import { useMutation } from '@tanstack/react-query';

import { fakeLoader, revokeMQTTV2Certificate } from '@/services/apiService';
import { ProjectInstance } from '@/types';

type RevokeMQTTV2CertificateDialogProps = Pick<AlertDialogProps, 'isOpen' | 'setIsOpen'> & {
  teamId: string;
  projectId: string;
  instance: ProjectInstance;
  certificateId: string;
  onSuccess: () => void;
};

export function RevokeMQTTV2CertificateDialog(props: RevokeMQTTV2CertificateDialogProps) {
  const revokeMQTTV2ClientCertificateMutation = useMutation({
    mutationFn: async (input: { id: string }) => {
      const [{ data }] = await Promise.all([
        revokeMQTTV2Certificate(props.teamId, props.projectId, props.instance, input.id),
        fakeLoader(),
      ]);

      return data;
    },
    onError: (e: any) => {
      console.error('revokeMQTTV2ClientCertificate::failed to revoke certificate', e);
      toast('Something went wrong. Please try again.', 'error');
    },
    onSuccess: props.onSuccess,
  });

  return (
    <Dialog isOpen={props.isOpen} setIsOpen={props.setIsOpen} title="Revoke Certificate">
      <>
        <p className="text-label-regular text-white-60">
          After revoking client certificates, it can take up to one hour for the MQTT broker to
          recognize the changes. If you suspect your credentials have been leaked, please contact
          support so we can take immediate action.
        </p>
        <div className="flex items-center justify-end gap-2">
          <a
            href="https://docs.high-mobility.com/help-center"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button intent="secondary">Contact support</Button>
          </a>
          <Button
            onClick={() =>
              revokeMQTTV2ClientCertificateMutation.mutate({ id: props.certificateId })
            }
            disabled={revokeMQTTV2ClientCertificateMutation.isPending}
          >
            {revokeMQTTV2ClientCertificateMutation.isPending ? 'Revoking' : 'Revoke'}
          </Button>
        </div>
      </>
    </Dialog>
  );
}
